module.exports = __webpack_public_path__ + "img/danelec-connect_negative.59ed434a.svg";